import { Injectable } from '@angular/core';
import { PCacheable } from 'ts-cacheable';
import { environment } from '../../environments/environment';
import { ApiService } from '../../shared/services/api.service';
import { DisplayLabel } from '../models/displayLabel';

@Injectable({
  providedIn: 'root',
})
export class SupportTypeService {
  constructor(private readonly api: ApiService) {}

  @PCacheable()
  public async findAll(): Promise<DisplayLabel[]> {
    return this.api.get<DisplayLabel[]>(environment.api.supportTypes);
  }

  public async findAllSupportTypesById(): Promise<Map<number, DisplayLabel>> {
    const supportTypes: DisplayLabel[] = await this.findAll();
    return new Map<number, DisplayLabel>(supportTypes.map((type: DisplayLabel) => [type.id, type] as [number, DisplayLabel]));
  }
}
